import { Lang } from 'Roblox';
import angular from 'angular';

const moduleConfig = function(languageResourceProvider) {
  languageResourceProvider.setLanguageKeysFromFile(Lang.CatalogResources);
  languageResourceProvider.setLanguageKeysFromFile(Lang.PrivateSalesResources);
  languageResourceProvider.setLanguageKeysFromFile(Lang.ItemResources);
};

const resellers = angular
  .module('resellers', ['robloxApp', 'resellersAppTemplates', 'cursorPagination', 'ui.bootstrap', 'thumbnails', 'systemFeedback'])
  .config(['languageResourceProvider', moduleConfig]);

export default resellers;
